var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalApplicantsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43384"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#C0DAFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "leads"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0595 38.6641C26.6424 38.6641 25.4922 39.8143 25.4922 41.2313C25.4922 42.6484 26.6424 43.7986 28.0595 43.7986C29.4765 43.7986 30.6267 42.6484 30.6267 41.2313C30.6267 39.8143 29.4765 38.6641 28.0595 38.6641ZM28.0595 39.6185C28.9495 39.6185 29.6723 40.3413 29.6723 41.2313C29.6723 42.1213 28.9495 42.8441 28.0595 42.8441C27.1694 42.8441 26.4466 42.1213 26.4466 41.2313C26.4466 40.3413 27.1694 39.6185 28.0595 39.6185Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4423 22.646C45.0252 22.646 43.875 23.7962 43.875 25.2133C43.875 26.6303 45.0252 27.7805 46.4423 27.7805C47.8593 27.7805 49.0095 26.6303 49.0095 25.2133C49.0095 23.7962 47.8593 22.646 46.4423 22.646ZM46.4423 23.6004C47.3323 23.6004 48.0551 24.3233 48.0551 25.2133C48.0551 26.1033 47.3323 26.8261 46.4423 26.8261C45.5523 26.8261 44.8294 26.1033 44.8294 25.2133C44.8294 24.3233 45.5523 23.6004 46.4423 23.6004Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4169 15.6392C22.9998 15.6392 21.8496 16.7894 21.8496 18.2064C21.8496 19.6235 22.9998 20.7737 24.4169 20.7737C25.8339 20.7737 26.9841 19.6235 26.9841 18.2064C26.9841 16.7894 25.8339 15.6392 24.4169 15.6392ZM24.4169 16.5936C25.3069 16.5936 26.0297 17.3164 26.0297 18.2064C26.0297 19.0964 25.3069 19.8192 24.4169 19.8192C23.5269 19.8192 22.8041 19.0964 22.8041 18.2064C22.8041 17.3164 23.5269 16.5936 24.4169 16.5936Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3584 46.7846C32.3584 46.1511 32.1071 45.5433 31.6598 45.096C31.2126 44.6488 30.6048 44.3994 29.9722 44.3994C28.8045 44.3994 27.3137 44.3994 26.1459 44.3994C25.5133 44.3994 24.9055 44.6488 24.4583 45.096C24.0111 45.5433 23.7598 46.1511 23.7598 46.7846V50.609C23.7598 50.8727 23.9729 51.0849 24.2366 51.0849H31.8815C32.1453 51.0849 32.3584 50.8727 32.3584 50.609V46.7846ZM31.4047 46.7846V50.1331H24.7135V46.7846C24.7135 46.4033 24.8645 46.0393 25.133 45.7726C25.4015 45.5032 25.7656 45.3512 26.1459 45.3512H29.9722C30.3525 45.3512 30.7166 45.5032 30.9852 45.7726C31.2537 46.0393 31.4047 46.4033 31.4047 46.7846Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7431 30.7666C50.7431 30.133 50.4918 29.5252 50.0446 29.078C49.5974 28.6308 48.9896 28.3813 48.357 28.3813C47.1892 28.3813 45.6985 28.3813 44.5307 28.3813C43.8981 28.3813 43.2903 28.6308 42.8431 29.078C42.3959 29.5252 42.1445 30.133 42.1445 30.7666V34.5909C42.1445 34.8547 42.3576 35.0668 42.6214 35.0668H50.2663C50.53 35.0668 50.7431 34.8547 50.7431 34.5909V30.7666ZM49.7894 30.7666V34.115H43.0982V30.7666C43.0982 30.3853 43.2492 30.0212 43.5177 29.7546C43.7863 29.4851 44.1504 29.3331 44.5307 29.3331H48.357C48.7373 29.3331 49.1014 29.4851 49.3699 29.7546C49.6385 30.0212 49.7894 30.3853 49.7894 30.7666Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7178 23.7597C28.7178 23.1262 28.4664 22.5184 28.0192 22.0711C27.572 21.6239 26.9642 21.3745 26.3316 21.3745C25.1638 21.3745 23.6731 21.3745 22.5053 21.3745C21.8727 21.3745 21.2649 21.6239 20.8177 22.0711C20.3705 22.5184 20.1191 23.1262 20.1191 23.7597V27.5841C20.1191 27.8478 20.3322 28.06 20.596 28.06H28.2409C28.5047 28.06 28.7178 27.8478 28.7178 27.5841V23.7597ZM27.7641 23.7597V27.1082H21.0728V23.7597C21.0728 23.3784 21.2238 23.0144 21.4924 22.7477C21.7609 22.4783 22.125 22.3263 22.5053 22.3263H26.3316C26.7119 22.3263 27.076 22.4783 27.3445 22.7477C27.6131 23.0144 27.7641 23.3784 27.7641 23.7597Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7257 39.4112C36.7257 38.0931 35.6568 37.0249 34.3388 37.0249C31.1861 37.0249 24.9282 37.0249 21.7755 37.0249C20.4576 37.0249 19.3887 38.0931 19.3887 39.4112C19.3887 42.2383 19.3887 47.5092 19.3887 50.3363C19.3887 51.6544 20.4576 52.7226 21.7755 52.7226H25.3615L27.6755 55.8084C27.7656 55.9286 27.9073 55.9994 28.0572 55.9994C28.2071 55.9994 28.3488 55.9286 28.4389 55.8084L30.7528 52.7226H34.3388C35.6568 52.7226 36.7257 51.6544 36.7257 50.3363V39.4112ZM35.7706 39.4112V50.3363C35.7706 51.1273 35.1301 51.7686 34.3388 51.7686H30.5145C30.3646 51.7686 30.2229 51.8394 30.1328 51.9596L28.0572 54.7262L25.9816 51.9596C25.8915 51.8394 25.7498 51.7686 25.5999 51.7686H21.7755C20.9843 51.7686 20.3438 51.1273 20.3438 50.3363V39.4112C20.3438 38.6202 20.9843 37.9788 21.7755 37.9788C24.9282 37.9788 31.1861 37.9788 34.3388 37.9788C35.1301 37.9788 35.7706 38.6202 35.7706 39.4112Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1104 23.3946C55.1104 22.0765 54.0415 21.0083 52.7236 21.0083C49.5709 21.0083 43.313 21.0083 40.1603 21.0083C38.8424 21.0083 37.7734 22.0765 37.7734 23.3946C37.7734 26.2217 37.7734 31.4926 37.7734 34.3197C37.7734 35.6378 38.8424 36.706 40.1603 36.706H43.7463L46.0602 39.7918C46.1503 39.912 46.292 39.9828 46.4419 39.9828C46.5918 39.9828 46.7335 39.912 46.8236 39.7918L49.1376 36.706H52.7236C54.0415 36.706 55.1104 35.6378 55.1104 34.3197V23.3946ZM54.1554 23.3946V34.3197C54.1554 35.1107 53.5148 35.752 52.7236 35.752H48.8992C48.7493 35.752 48.6076 35.8228 48.5175 35.943L46.4419 38.7096L44.3664 35.943C44.2763 35.8228 44.1345 35.752 43.9847 35.752H40.1603C39.369 35.752 38.7285 35.1107 38.7285 34.3197V23.3946C38.7285 22.6036 39.369 21.9622 40.1603 21.9622C43.313 21.9622 49.5709 21.9622 52.7236 21.9622C53.5148 21.9622 54.1554 22.6036 54.1554 23.3946Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.087 16.3863C33.087 15.0682 32.0181 14 30.7002 14C27.5475 14 21.2896 14 18.1368 14C16.8189 14 15.75 15.0682 15.75 16.3863C15.75 19.2134 15.75 24.4843 15.75 27.3114C15.75 28.6295 16.8189 29.6977 18.1368 29.6977H21.7229L24.0368 32.7835C24.1269 32.9037 24.2686 32.9745 24.4185 32.9745C24.5684 32.9745 24.7101 32.9037 24.8002 32.7835L27.1141 29.6977H30.7002C32.0181 29.6977 33.087 28.6295 33.087 27.3114V16.3863ZM32.1319 16.3863V27.3114C32.1319 28.1024 31.4914 28.7437 30.7002 28.7437H26.8758C26.7259 28.7437 26.5842 28.8145 26.4941 28.9347L24.4185 31.7013L22.3429 28.9347C22.2528 28.8145 22.1111 28.7437 21.9612 28.7437H18.1368C17.3456 28.7437 16.7051 28.1024 16.7051 27.3114V16.3863C16.7051 15.5953 17.3456 14.9539 18.1368 14.9539C21.2896 14.9539 27.5475 14.9539 30.7002 14.9539C31.4914 14.9539 32.1319 15.5953 32.1319 16.3863Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.3
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalApplicantsIcon);
export default __webpack_public_path__ + "static/media/TotalApplicants_icon.277755880ed01b5682684d7d0a585b39.svg";
export { ForwardRef as ReactComponent };